import { render, staticRenderFns } from "./TileComments.vue?vue&type=template&id=5e71ca07&"
import script from "./TileComments.vue?vue&type=script&lang=js&"
export * from "./TileComments.vue?vue&type=script&lang=js&"
import style0 from "./TileComments.vue?vue&type=style&index=0&id=5e71ca07&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VIcon,VSpacer})
